import { render } from "./ServiceCenter.vue?vue&type=template&id=25ba9a9b&scoped=true"
import script from "./ServiceCenter.vue?vue&type=script&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&lang=js"

import "./ServiceCenter.vue?vue&type=style&index=0&id=25ba9a9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ba9a9b"],['__file',"src/views/ServiceCenter/ServiceCenter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25ba9a9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25ba9a9b', __exports__)) {
    api.reload('25ba9a9b', __exports__)
  }
  
  module.hot.accept("./ServiceCenter.vue?vue&type=template&id=25ba9a9b&scoped=true", () => {
    api.rerender('25ba9a9b', render)
  })

}


export default __exports__